<template>
    <section class="facetList -shaded searchMachine__facetList">
        <header class="facetList__header">
            <h2 class="facetList__heading">Show Only</h2>
        </header>
        <ul class="facetList__list">
            <li
                class="facetList__item"
                v-for="(type, index) in availableTypes"
                :key="index">
                <input
                    type="checkbox"
                    class="checkbox"
                    :value="type.key"
                    v-model="appliedTypes"
                    :id="type.key">
                <label :for="type.key">{{ type.key.charAt(0).toUpperCase() + type.key.slice(1) }}<span class="facetList__count">({{ type.doc_count }})</span></label>
            </li>
        </ul>
    </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    methods: {
        ...mapActions('search', ['updateTypes']),
    },
    computed: {
        ...mapState('search', ['availableTypes']),
        appliedTypes: {
            get() {
                return this.$store.state.search.types;
            },
            set(value) {
                this.updateTypes(value);
            },
        },
    },
};
</script>
